import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MButton } from "@/components/ui/atoms/MButtons";
import MaatraLogo from "@/components/ui/atoms/MaatraLogo";
import styles from "./SignupLanding.module.css";
import {
  getPreferredLoginMethod,
  clearStoragePreservingTours,
} from "@/utils/storage-utils";

const SignupLanding: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const preferredMethod = getPreferredLoginMethod() || "mobile";

  // Clear any stale auth tokens when landing here — whether redirected by
  // a failed refresh (401 path) or a normal logout. Ensures every re-login
  // starts from a clean state. Users who never reach this page are unaffected.
  useEffect(() => {
    clearStoragePreservingTours();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <div className={styles.watermark}>
          <MaatraLogo fill="#e9e3f5" size={400} />
        </div>
        <div className={styles.logoCircleWrapper}>
          <div className={styles.logoCircleInner}>
            <MaatraLogo fill="#fff" size={45} />
          </div>
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div>
          <h1 className={styles.title}>
            {t("auth.signupLanding.title")
              .split("\n")
              .map((line, i) => (
                <React.Fragment key={i}>
                  <span
                    className={
                      i === 0 ? styles.titleFirstLine : styles.titleRestLines
                    }
                  >
                    {line}
                  </span>
                  {i < t("auth.signupLanding.title").split("\n").length - 1 && (
                    <br />
                  )}
                </React.Fragment>
              ))}
          </h1>
        </div>

        {/* Buttons */}
        <div className={styles.buttonContainer}>
          <MButton
            variant="filled"
            size="lg"
            onClick={() =>
              navigate("/login/form", {
                state: { mode: preferredMethod, isLogin: true },
              })
            }
          >
            {t("auth.signupLanding.loginButton")}
          </MButton>
          <MButton
            variant="outline"
            size="lg"
            onClick={() => navigate("/register/info")}
          >
            {t("auth.signupLanding.signupButton")}
          </MButton>
          <button
            type="button"
            className={styles.exploreLink}
            onClick={() => navigate("/explore-maatra")}
          >
            {t("auth.signupLanding.whatCanMaatraDo")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupLanding;
